import React, {useEffect, useRef} from "react"
import styled from "styled-components"

import {H2} from "@irati/ui/src/Typography/Heading"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import qs from "qs"
import Button from "@irati/ui/src/Button"
import tracking from "@irati-tracking/recognition/recognition"

import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Flex from "@irati/ui/src/Flex"
import {Body, Label} from "@irati/ui/src/Typography"
import RewardPointsIcon from "@irati/ui/images/reward_point.svg"
import {FeedItemType} from "@irati/recognition/enums"
import recogniseSuccess from "../../../images/recognise-success.gif"

const Image = styled.img`
  height: ${({height}) => height || "120px"};
  width: ${({width}) => width || "120px"};
`
interface Props extends InjectIntlProps {
  onClickButton: () => void
  onHide: () => void
  timeoutMilliseconds?: number
  isNew?: boolean
  type: FeedItemType
}
const getMessageText = (isNew: boolean, type: FeedItemType) => {
  if (type === FeedItemType.GROUP_RECOGNITION) {
    return "recognition.successManager.lbl.groupCelebrationRewardCreated"
  }
  return isNew ? "recognition.successManager.lbl.rewardAndRecognitionCreated" : "recognition.successManager.lbl.rewardAdded"
}
const getCTAText = (isNew: boolean, type: FeedItemType) => {
  if (type === FeedItemType.GROUP_RECOGNITION) {
    return "recognition.popup.rewardRecognition.success.createAgainButton"
  }
  return isNew
    ? "recognition.popup.createRecognition.success.rewardAgainButton"
    : "recognition.popup.rewardRecognition.success.createAgainButton"
}
const RecognitionSuccess: React.FC<Props> = (props) => {
  const theme = useTheme()
  const {formatMessage, onClickButton, onHide, timeoutMilliseconds = 30000, isNew = false, type} = props
  const closeSuccessTimeout = useRef(-1)
  useEffect(() => {
    if (type === FeedItemType.RECOGNITION) {
      const query = qs.parse(window.location.search.replace("?", ""))
      const rewardSource = query.type === "add_reward" ? "add_reward" : "reward"
      tracking.recognitionConfirmation({type: "standard", source: rewardSource})
    }
    closeSuccessTimeout.current = setTimeout(onHide, timeoutMilliseconds)
    return () => {
      clearTimeout(closeSuccessTimeout.current)
    }
  }, [])
  const ctaText = getCTAText(isNew, type)
  const msgText = getMessageText(isNew, type)
  return (
    <Flex direction="column" alignItems="center" justifyContent="center" gap={3}>
      <Flex alignItems="center" gap={3} marginTop={theme.spacing.three}>
        <Image alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})} src={RewardPointsIcon} />
        {isNew && (
          <>
            <Icon icon={IconTypes.plus} color={theme.colors.greys.medium} />
            <Image
              width="150px"
              height="150px"
              alt={formatMessage({id: "recognition.popup.createRecognition.success.image"})}
              src={recogniseSuccess}
            />
          </>
        )}
      </Flex>
      <H2>
        <FormattedMessage id={msgText} />
      </H2>
      {isNew && (
        <Body large maxWidth="100%" textAlign="center">
          <FormattedMessage id="recognition.popup.createRecognition.success.body" />
        </Body>
      )}
      <Button primary large full onClick={onClickButton}>
        <FormattedMessage id={ctaText} />
      </Button>
      {!isNew && (
        <Flex alignItems="center" justifyContent="center" gap={theme.spacing.one}>
          <Icon icon={IconTypes.info} color={theme.colors.greys.medium} />
          <Label small color={theme.colors.greys.medium}>
            <FormattedMessage id="recognition.successManager.lbl.hintRewardCreated" />
          </Label>
        </Flex>
      )}
    </Flex>
  )
}

export default injectIntl(RecognitionSuccess)
